import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from 'app/store';
import { AppUserModel, AppUserData } from 'features/app_user/data/AppUserModel';
import { AppUserActions } from 'features/app_user/appUserSlice';
import { pocketBase } from 'config';

import { asGermanDateDMY } from 'utils/DateFormatter';
import { isBasisversion, isLicenseValid } from 'utils/appUserUtils';
import { SnackbarActions } from 'features/snackbar/snackbarSlice';
import PocketBase, { ClientResponseError } from 'pocketbase';
var createHash = require('create-hash')

export interface AuthState {
    loading: boolean;
    error: any;
}

const initialState: AuthState = {
    loading: false,
    error: undefined
};

function BrowserCheck() {
    var N = navigator.appName, ua = navigator.userAgent, tem;
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident)\/?\s*(\.?\d+(\.\d+)*)/i);
    if (M && (tem = ua.match(/version\/([.\d]+)/i)) != null) { M[2] = tem[1]; }
    M = M ? [M[1], M[2]] : [N, navigator.appVersion, '-?'];
    return M;
}

const jsonCheckSum = (json: AppUserData) => {

    var jsonTmp: AppUserData = { ...json };
    jsonTmp.backupDate = 0;

    const data = JSON.stringify(jsonTmp, null, 2)
    var hash = createHash('md5')
    return hash.update(data).digest("hex");

    // return hash.read()
}

const saveData = async (user: AppUserModel) => {
    const pb = new PocketBase(pocketBase.url);
    // Save Storage
    const obj = localStorage;
    // console.log(obj, JSON.parse(obj.getItem('persist:root') ?? ''))

    if (obj.getItem('persist:root')) {
        const dataApp = JSON.parse(obj.getItem('persist:root') ?? '');
        const browserAgent = BrowserCheck().join('_').replace(/\./g, "_"); // browserName()

        // console.log(browserAgent)

        if (dataApp.savedConsultations || dataApp.customerStore) {

            let datenow = Date.now()

            const dataCons: AppUserData = {
                'backupDate': datenow,
                'currentConsultation': dataApp.currentConsultation,
                'customerStore': dataApp.customerStore,
                'savedConsultations': dataApp.savedConsultations
            }

            // Traffic sparen?
            // const dataConsLite: AppUserData = {
            //     'backupDate': datenow,
            //     'currentConsultation': '',
            //     'customerStore': '',
            //     'savedConsultations': '',
            //     'checkSum': jsonCheckSum(dataCons)
            // }

            var backupBrowser: AppUserData = {};
            for (var browser in user.appData) {
                if (browser === browserAgent) {
                    backupBrowser = user.appData[browser]
                }
            }

            // console.log(jsonCheckSum(dataCons), backupBrowser.checkSum, dataCons, backupBrowser.checkSum) // _.isEqual(dataCons, backupBrowser),

            if (!user.appData || jsonCheckSum(dataCons) !== backupBrowser.checkSum) {
                // appData
                const appDataUser = await pb.collection('appData').getList(1, 1, {
                    filter: `title="${browserAgent}"`,
                });
                // console.log('total', appDataUser)
                if ((appDataUser?.totalItems ?? 0) === 0) {
                    const newAppDataUser = await pb.collection('appData').create({ ...dataCons, title: browserAgent })
                        .catch((error) => { console.log('err appData', error) })
                    if (newAppDataUser?.id) {
                        await pb.collection("users").update(pb.authStore.record?.id ?? '', {
                            // append single id
                            "appData+": newAppDataUser.id,
                        }).catch((error) => { console.log('err appData add', error) })
                    }
                } else {
                    // Update appData
                    // console.log('Update appData', appDataUser)
                    if ((appDataUser.items ?? []).length > 0) {
                        await pb.collection('appData').update(appDataUser.items[0].id, { ...dataCons })
                            .catch((error) => { console.log('err appData', error) })
                    }
                }

                // appDataBackup
                const appDataBackup = await pb.collection('appDataBackup').getList(1, 1, {
                    filter: `title="${browserAgent}"`,
                });
                // console.log('total', appDataBackup?.totalItems)
                if ((appDataBackup?.totalItems ?? 0) === 0) {
                    const newAppDataBackup = await pb.collection('appDataBackup').create({ ...dataCons, title: browserAgent })
                        .catch((error) => { console.log('err appDataBackup', error) })
                    if (newAppDataBackup?.id) {
                        await pb.collection("users").update(pb.authStore.record?.id ?? '', {
                            // append single id
                            "backups+": newAppDataBackup.id,
                        }).catch((error) => { console.log('err appDataBackup add', error) })
                    }
                } else {
                    // Update Backup
                    // console.log('Update backup', appDataBackup)
                    if ((appDataBackup.items ?? []).length > 0) {
                        await pb.collection('appDataBackup').update(appDataBackup.items[0].id, { ...dataCons })
                            .catch((error) => { console.log('err appDataBackup', error) })
                    }
                }

                return true;
                // dispatch(SnackbarActions.show('Datenbank erfolgreich gespeichert!'));
                // await new Promise((r) => setTimeout(r, 3000));
                // dispatch(SnackbarActions.hide());
            }
        }

    }
    return false;
}

export const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        setLoading: (state: AuthState, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state: AuthState, action: PayloadAction<string | undefined>) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const logout = (appUser?: AppUserModel): AppThunk => async (dispatch) => {
    const pb = new PocketBase(pocketBase.url);
    try {
        // Backup
        if (appUser && typeof appUser.id != 'undefined') {

            if (pb.authStore.record) {
                await pb.collection('users').update(pb.authStore.record.id, {
                    'lastLogout': Date.now()
                }).catch((error) => { return })
            }

            await saveData(appUser);
        }

        pb.authStore.clear();
        // console.log('manual logout');
        dispatch(AppUserActions.onLogout());
    } catch (err) {
        console.error(err);
    }
};

export const attemptLogin = (props: { email: string; password: string }): AppThunk => async (dispatch) => {

    const email = props.email.toLowerCase().trim();
    const password = props.password
    const pb = new PocketBase(pocketBase.url);

    dispatch(AuthActions.setLoading(true));
    try {
        const authData = await pb.collection('users').authWithPassword(
            email,
            password
        ).catch((error: ClientResponseError) => {
            // console.log(error.status)
            if (error.status === 403 || error.status === 400) {
                dispatch(
                    AuthActions.setError(
                        "Aufgrund einer Systemumstellung muss Dein Passwort neu gesetzt werden. Bitte nutze dafür die 'Passwort zurücksetzen' Funktion.\n\n"
                    )
                )
            } else {
                dispatch(
                    AuthActions.setError(
                        "Bitte überprüfe Dein Passwort, alternativ nutze dafür die 'Passwort zurücksetzen' Funktion.\n\n"
                    )
                )
            }

            localStorage.setItem("email", email.trim().toLowerCase());
            return
        });

        if (authData?.record?.id) {
            // appData
            // const records = await pb.collection('appData').getFullList({
            //     sort: '-backupDate',
            //     filter: 'someField1 != someField2',
            // });
            const appData: any = []
            // records.forEach((aD: any) => {
            //     appData[aD.title] = aD
            // });
            // // backups
            // const recordsBackup = await pb.collection('appDataBackup').getFullList({
            //     sort: '-backupDate',
            // });
            const appDataBackup: any = []
            // recordsBackup.forEach((aD: any) => {
            //     appDataBackup[aD.title] = aD
            // });

            const user = { ...authData.record as any, appData: appData ?? [], backups: appDataBackup ?? [] } as AppUserModel;

            // set LastLogin
            await pb.collection('users').update(user.id, {
                'lastLogin': Date.now()
            });

            // console.log('####1#', { last: user.lastLogin ?? 0, user })

            if (!user.verified) {
                dispatch(
                    AuthActions.setError(
                        'Aufgrund einer Systemumstellung muss Dein Passwort neu gesetzt werden. Bitte nutze dafür die "Passwort zurücksetzen" Funktion.\n\n'
                    )
                );
                return;
            }

            if (!user.hasWebLicense) {
                dispatch(
                    AuthActions.setError(
                        'Ihre Lizenz ist nur für die iOS Version gültig. Bitte besuchen Sie unseren Shop unter https://shop.dfiav.de, falls Sie die Web Version zusätzlich erwerben möchten.'
                    )
                );
                return;
            }

            if (!isLicenseValid(user)) {
                dispatch(AuthActions.setError(`Ihre Lizenz ist am ${asGermanDateDMY(new Date(user.validUntil))} abgelaufen. Bitte erneuern Sie Ihre Lizenz in unserem Webshop: `));
                return;
            }



            if (!isBasisversion(user) && user.hasTestLicense === true) {
                dispatch(AuthActions.setError(`Ihre Testlizenz ist am ${asGermanDateDMY(new Date(user.validUntil))} abgelaufen. Bitte erneuern Sie Ihre Lizenz in unserem Webshop: `));
                return;
            }

            if (await saveData(user)) {
                dispatch(SnackbarActions.show('Datenbank erfolgreich gesichert!'));
            }

            dispatch(AuthActions.setError(undefined));
            dispatch(AppUserActions.onLoginSuccess(user));
        }
    } catch (err: any) {
        console.error(err);
        dispatch(dispatch(AuthActions.setError(err)));
    }
    dispatch(AuthActions.setLoading(false));
};

export const AuthActions = authSlice.actions;
export default authSlice.reducer;
